import {
    postConfiCostLoading,
    postConfiCostRequest,
    postConfiCostSuccess,
    postConfiCostReject,
    postConfiCostReset
} from "../../actions/costGlobal/post";

export const postConfiCost = (formData) => async (dispatch, getState) => {
    dispatch(postConfiCostLoading());
    try {
        const { data } = await postConfiCostRequest(formData, getState);
        dispatch(postConfiCostSuccess(data))
    } catch (error) {
        dispatch(postConfiCostReject(error))
    } finally {
        setTimeout(() => { dispatch(postConfiCostReset()) }, 3000);
    }
    return Promise.resolve();
};